var device = {
    tablet: "(min-width: 768px)",
    laptop: "(min-width: 992px)",
    desktop: "(min-width: 1200px)",
};
export default device;
//# sourceMappingURL=device.js.map